import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import FilterBar from './filterBar';
import { useDispatch, useSelector } from 'react-redux';
import WebMetricsInfo from './webMetricsInfo';
import { actions as paidSearchAction } from '../../../redux/reducers/paidSearchReducer';
import TotalReachChart from './totalReachChart';
import TotalEngagementSummaryChart from './totalEngagementSummaryChart';
import CTRChart from './CTRChart';
import CPCChart from './CPCChart';
import TopHeadlinesChart from './topHeadlinesChart';
import TopReachChart from './topReachChart';
import TopEngagementChart from './topEngagementChart';
import TopCTRChart from './topCTRChart';
import GoogleAdWordsCTRChart from './googleAdWordCTR';
import BeingAdsCTRChart from './beingAdsCTR';
import WorstReachChart from './worstReachChart';
import WorstEngagementChart from './worstEngagementChart';
import WorstCTRChart from './worstCTRChart';
import { getPaidSearch } from '../../../redux/thunks/paidSearchThunk';
import { getWebMatrixCostDataFalse } from '../../../redux/thunks/webMatrixThunks';

const componentConfig = {
    150: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: true,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: true,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
        },
    },
    165: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: true,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: true,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
            topHCPSearchChart: true,
            worstHCPSearchChart: true,
            topSearchClicksChart: true,
            worstSearchClicksChart: true,
            topAffiliationsHCPChart: true,
        },
    },
    61: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: true,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: true,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
        },
    },
    94: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
        },
    },
    91: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
        },
    },
    66: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: true,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: true,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
            topHCPSearchChart: false,
            worstHCPSearchChart: false,
            topSearchClicksChart: false,
            worstSearchClicksChart: false,
            topAffiliationsHCPChart: false,
        },
    },
    67: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
            topHCPSearchChart: true,
            worstHCPSearchChart: true,
            topSearchClicksChart: true,
            worstSearchClicksChart: true,
            topAffiliationsHCPChart: true,
        },
    },
    98: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
            topHCPSearchChart: true,
            worstHCPSearchChart: true,
            topSearchClicksChart: true,
            worstSearchClicksChart: true,
            topAffiliationsHCPChart: true,
        },
    },
    99: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
            topHCPSearchChart: true,
            worstHCPSearchChart: true,
            topSearchClicksChart: true,
            worstSearchClicksChart: true,
            topAffiliationsHCPChart: true,
        },
    },
    103: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
        },
    },
    104: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
        },
    },
    105: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: false,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
        },
    },
    16: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: true,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: false,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: true,
            worstEngagementChart: true,
            worstCTRChart: true,
            topHCPSearchChart: false,
            worstHCPSearchChart: false,
            topSearchClicksChart: false,
            worstSearchClicksChart: false,
            topAffiliationsHCPChart: false,
        },
    },
    default: {
        showComponents: {
            webMetricsInfo: true,
            totalReachSummary: true,
            totalEngagementSummary: true,
            ctr: true,
            cpc: false,
            topHeadlinesChart: true,
            googleAdwords: false,
            beingAds: false,
            brandedKeywordsByReach: true,
            unBrandedKeywordsByReach: true,
            brandedKeywordsByEngagement: true,
            unBrandedKeywordsByEngagement: true,
            wortReachChart: false,
            worstEngagementChart: false,
            worstCTRChart: false,
            topHCPSearchChart: false,
            worstHCPSearchChart: false,
            topSearchClicksChart: false,
            worstSearchClicksChart: false,
            topAffiliationsHCPChart: false,
        },
    },
};

const PaidSearchEngagement = () => {
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { startDateRange, endDateRange } = useSelector(
        (state) => state.filter,
    );
    const { resetToInitialState } = paidSearchAction;

    const getConfig = (companyId) =>
        componentConfig[companyId] || componentConfig.default;
    const config = getConfig(company.id);

    useEffect(() => {
        if (company.id) {
            dispatch(resetToInitialState());
            dispatch(
                getPaidSearch({
                    companyId: company.id,
                    startDate: startDateRange,
                    endDate: endDateRange,
                }),
            );
            dispatch(
                getWebMatrixCostDataFalse({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                }),
            );
        }
    }, [company.id, startDateRange, endDateRange]);

    return (
        <>
            <FilterBar />
            <Grid container spacing={2}>
                {config.showComponents.webMetricsInfo && (
                    <Grid item xs={12}>
                        <WebMetricsInfo />
                    </Grid>
                )}
                {config.showComponents.totalReachSummary && (
                    <Grid item xs={6}>
                        <TotalReachChart />
                    </Grid>
                )}
                {config.showComponents.totalEngagementSummary && (
                    <Grid item xs={6}>
                        <TotalEngagementSummaryChart />
                    </Grid>
                )}
                {config.showComponents.ctr && (
                    <Grid item xs={6}>
                        <CTRChart />
                    </Grid>
                )}
                {config.showComponents.cpc && (
                    <Grid item xs={6}>
                        <CPCChart />
                    </Grid>
                )}
                {config.showComponents.googleAdwords && (
                    <Grid item xs={6}>
                        <GoogleAdWordsCTRChart />
                    </Grid>
                )}
                {config.showComponents.beingAds && (
                    <Grid item xs={6}>
                        <BeingAdsCTRChart />
                    </Grid>
                )}
                {config.showComponents.brandedKeywordsByReach && (
                    <Grid item xs={12}>
                        <TopHeadlinesChart
                            title="Top Performing Headlines"
                            type="headline"
                        />
                    </Grid>
                )}

                {config.showComponents.unBrandedKeywordsByReach && (
                    <Grid item xs={12}>
                        <TopReachChart />
                    </Grid>
                )}
                {config.showComponents.brandedKeywordsByEngagement && (
                    <Grid item xs={12}>
                        <TopEngagementChart />
                    </Grid>
                )}
                {config.showComponents.unBrandedKeywordsByEngagement && (
                    <Grid item xs={12}>
                        <TopCTRChart />
                    </Grid>
                )}
                {config.showComponents.wortReachChart && (
                    <Grid item xs={12}>
                        <WorstReachChart />
                    </Grid>
                )}
                {config.showComponents.worstEngagementChart && (
                    <Grid item xs={12}>
                        <WorstEngagementChart
                            title="Least Performing 10 Keywords by Engagement"
                            type="worst_engagements"
                        />
                    </Grid>
                )}
                {config.showComponents.worstCTRChart && (
                    <Grid item xs={12}>
                        <WorstCTRChart />
                    </Grid>
                )}
                {config.showComponents.topHCPSearchChart && (
                    <Grid item xs={12}>
                        <TopHeadlinesChart
                            title="Top 10 Keywords by HCP Search Clicks"
                            type="HCP_search"
                        />
                    </Grid>
                )}
                {config.showComponents.topSearchClicksChart && (
                    <Grid item xs={12}>
                        <TopHeadlinesChart
                            title="Top 10 Keywords by Total Search Clicks"
                            type="search_click"
                        />
                    </Grid>
                )}
                {config.showComponents.worstHCPSearchChart && (
                    <Grid item xs={12}>
                        <WorstEngagementChart
                            title="Worst 10 Keywords by HCP Search Clicks"
                            type="worst_hcp_search"
                        />
                    </Grid>
                )}
                {config.showComponents.worstSearchClicksChart && (
                    <Grid item xs={12}>
                        <WorstEngagementChart
                            title="Worst 10 Keywords by Total Search Clicks"
                            type="worst_hcp_search"
                        />
                    </Grid>
                )}
                {config.showComponents.topAffiliationsHCPChart && (
                    <Grid item xs={12}>
                        <TopHeadlinesChart
                            title="Top 10 Affiliations by HCP Search Clicks"
                            type="affiliations_hcp"
                        />
                    </Grid>
                )}
            </Grid>
        </>
    );
};

export default PaidSearchEngagement;
